<template lang="pug">
	section#agradecimento
		.wrapper
			h1 MUITO OBRIGADO!
</template>

<script>
export default {
	name: "section-agradecimento"
}
</script>

<style lang="stylus" scoped src="./Agradecimento.styl"></style>
